<script setup lang="ts">
import { defineProps, ref } from 'vue';
import {
  Dialog,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogScrollContent
} from "@/components/ui/dialog";

const props = withDefaults(defineProps<{
  actionUrl: string,
  batchTypes: Array<{
    value: string,
    label: string
  }>
  activities: Array<{
    value: string,
    label: string
  }>
}>(), {
  batchTypes: [],
  activities: []
},);

const selectedBatchType = ref('')

const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

</script>

<template>
  <Dialog>
    <DialogTrigger class="btn btn-primary mt-2">
      {{ $t('Create deposit batch') }}
    </DialogTrigger>
    <DialogScrollContent>
      <DialogHeader>
        <DialogTitle>
          {{ $t('Create deposit batch') }}
        </DialogTitle>
      </DialogHeader>

      <form method="POST" :action="props.actionUrl">
        <input type="hidden" name="_token" :value="csrfToken">
        <div class="form-group">
          <label for="frm_create_deposit_type">{{ $t('Type') }}</label>
          <select name="type" id="frm_create_deposit_type" class="form-control" v-model="selectedBatchType">
            <option v-for="batchType in batchTypes" :value="batchType.value">{{ batchType.label }}</option>
          </select>
        </div>
        <template v-if="selectedBatchType === 'registration_with_order_item'">
          <div class="form-group">
            <label for="frm_add_deposit_activity">{{ $t("Activity") }}</label>
            <select name="activity_id" id="frm_add_deposit_activity" class="form-control">
              <option value="">{{ $t("All activities") }}</option>
              <option v-for="activity in activities" :value="activity.value">{{ activity.label }}</option>
            </select>
          </div>
        </template>
        <button type="submit" class="btn btn-primary">
          {{ $t('Create') }}
        </button>
      </form>

    </DialogScrollContent>
  </Dialog>
</template>

<style scoped>

</style>